import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "flex-1 flex flex-col md:flex-row overflow-hidden bg-muted/20" }
const _hoisted_3 = { class: "w-full md:w-[40%] flex flex-col border-r bg-background" }
const _hoisted_4 = { class: "relative flex-1" }
const _hoisted_5 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 p-3 bg-destructive/10 border-t border-destructive/20 text-destructive text-sm flex items-start gap-2 max-h-[40%] overflow-auto"
}
const _hoisted_6 = { class: "whitespace-pre-wrap font-sans text-xs" }
const _hoisted_7 = { class: "w-full md:w-[60%] flex flex-col bg-slate-50 dark:bg-slate-900 overflow-hidden" }
const _hoisted_8 = { class: "flex-1 overflow-auto p-4 flex items-center justify-center" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "text-muted-foreground flex items-center gap-2"
}

import { ref, watch, onMounted, nextTick } from 'vue'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Check, Code2, AlertCircle } from 'lucide-vue-next'
import mermaid from 'mermaid'
import { torcazaMermaidConfig } from '@/config/mermaidTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'MermaidLiveEditorDialog',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const code = ref(`flowchart TD
    A[Christmas] -->|Get money| B(Go shopping)
    B --> C{Let me think}
    C -->|One| D[Laptop]
    C -->|Two| E[iPhone]
    C -->|Three| F[fa:fa-car Car]
`)
const svgContent = ref('')
const error = ref('')

let renderTimeout: ReturnType<typeof setTimeout> | null = null

const renderMermaid = async () => {
  if (!code.value.trim()) {
    svgContent.value = ''
    error.value = ''
    return
  }
  
  try {
    // Clear previous errors
    error.value = ''
    
    // Validate syntax first (throws if invalid)
    const isValid = await mermaid.parse(code.value)
    
    if (isValid) {
      // Create a unique id for the render
      const id = `mermaid-render-${Date.now()}`
      const { svg } = await mermaid.render(id, code.value)
      svgContent.value = svg
    }
  } catch (e: any) {
    console.error('Mermaid render error', e)
    error.value = e.message || 'Sintaxis de Mermaid inválida'
  }
}

const onInput = () => {
  if (renderTimeout) {
    clearTimeout(renderTimeout)
  }
  renderTimeout = setTimeout(() => {
    renderMermaid()
  }, 400)
}

watch(() => props.open, (newVal) => {
  if (newVal) {
    const editingCode = localStorage.getItem('editingDiagramCode');
    if (editingCode) {
      setTimeout(() => {
        code.value = editingCode;
        localStorage.removeItem('editingDiagramCode');
        renderMermaid();
      }, 300);
      return;
    }
  }

  if (newVal) {
    nextTick(() => {
      mermaid.initialize(torcazaMermaidConfig)
      renderMermaid()
    })
  }
}, { immediate: true })

const handleSave = () => {
  emit('save', code.value)
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: __props.open,
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-[90vw] w-[1200px] h-[90vh] flex flex-col p-0 gap-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), { class: "p-6 pb-4 border-b shrink-0 flex flex-row items-center justify-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(DialogTitle), { class: "flex items-center gap-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Code2), { class: "w-5 h-5 text-primary" }),
                    _cache[2] || (_cache[2] = _createTextVNode(" Editor Avanzado Mermaid ", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Escribe código Mermaid puro en el panel izquierdo y mira el resultado en tiempo real. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(Button), { onClick: handleSave }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Check), { class: "w-4 h-4 mr-2" }),
                    _cache[4] || (_cache[4] = _createTextVNode(" Insertar en Documento ", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "p-2 border-b bg-muted/40 text-sm font-medium text-muted-foreground" }, " Código Fuente ", -1)),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
                  onInput: onInput,
                  class: "w-full h-full p-4 resize-none outline-none font-mono text-sm bg-transparent",
                  spellcheck: "false",
                  placeholder: "Escribe tu código Mermaid aquí..."
                }, null, 544), [
                  [_vModelText, code.value]
                ]),
                (error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(AlertCircle), { class: "w-4 h-4 mt-0.5 shrink-0" }),
                      _createElementVNode("pre", _hoisted_6, _toDisplayString(error.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "p-2 border-b bg-muted/40 text-sm font-medium text-muted-foreground" }, " Previsualización en Vivo ", -1)),
              _createElementVNode("div", _hoisted_8, [
                (svgContent.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: svgContent.value,
                      class: "max-w-full max-h-full flex items-center justify-center",
                      style: {"width":"100%","height":"100%"}
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_unref(Code2), { class: "w-8 h-8 opacity-20" }),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "opacity-50" }, "Ingresa código para previsualizar", -1))
                    ]))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})